import axios from 'axios'
import {APIURL} from '../../constants';


export default {
	namespaced: true,
	state: {
		auth: undefined,
		account: undefined,
		isFetchingAccount: false
	},
	getters: {
		isLoggedIn(state)
		{
			return typeof state.auth !== 'undefined'
		},
		isAdmin(state)
		{
			return typeof state.auth !== 'undefined' &&
				state.auth.role === 'admin'
		},

		isModerator(state)
		{
			return typeof state.auth !== 'undefined' &&
				state.auth.role === 'moderator'
		},

		isFetchingAccount(state)
		{
			return state.isFetchingAccount;
		},

		account(state)
		{
			return state.account;
		},
	},

	actions: {
		login(context, payload)
		{
			let url = APIURL;
			if(payload.toRemote)
			{

				url = `${context.rootGetters['importer/to']}/`
			}
			//console.log(url)
			return axios.post(url + 'login', payload)
		},

		user()
		{
			return axios.get(APIURL + 'user');
			
		},

		account(context){
			context.commit('setIsFetchingAccount', true)
			axios.get(`${APIURL}user`)
				.then((res) => {
					context.commit('setAccount', res.data)
					context.commit('setIsFetchingAccount', false)
				})
				.catch((err) => {})
		},

		updateAccount(context, payload)
		{
			//console.log(payload)
			return axios.put(`${APIURL}account`, payload)

		},

		updatePassword(context, payload) {
			return axios.put(`${APIURL}account/password`, payload)
		}


	},

	mutations: {
		login(state, payload)
		{
			
			state.auth = payload.user;
		},

		user(state, payload)
		{
			state.auth = payload
		},

		setAccount(state, payload)
		{
			state.account = payload;
		},

		setIsFetchingAccount(state, payload) {
			state.isFetchingAccount = payload;
		}

	}
}